import * as Bixby from '$/core';
import {
  SETTINGS_INPROGRESS,
  SETTINGS_SUCCESS,
  SETTINGS_FAILURE,
  DISCLAIMER_ACKNOWLEDGED,
  DISCLAIMER_INVALIDATE_ACKNOWLEDGED,
  DATASITEHOST_INPROGRESS,
  DATASITEHOST_SUCCESS,
  DATASITEHOST_FAILURE,
  CREATE_DATASITEHOST,
  CREATE_DATASITEHOST_SUCCESS,
  CREATE_DATASITEHOST_FAILURE,
} from './types';
import { ThunkAction } from 'redux-thunk';
import { AppState } from '$/store';
import { SettingsService } from '$/services';
import { toastError, toastSuccess } from '$/store/toast/actions';
import { DisclaimerService } from '$/services/DisclaimerService';
import { DataSiteHostService } from '$/services/DataSiteHostService';

const settingsInProgress = () => {
  return { type: SETTINGS_INPROGRESS };
};
const settingsSuccess = (payload?: Bixby.Models.Settings) => {
  return { type: SETTINGS_SUCCESS, payload };
};
const settingsFailure = (error: Bixby.Models.BixbyError) => {
  return { type: SETTINGS_FAILURE, payload: error };
};

const dataSiteHostInProgress = () => {
  return { type: DATASITEHOST_INPROGRESS };
};
const dataSiteHostSuccess = (payload?: Bixby.Models.DataSiteHost[]) => {
  return { type: DATASITEHOST_SUCCESS, payload };
};
const dataSiteHostFailure = (error: Bixby.Models.BixbyError) => {
  return { type: DATASITEHOST_FAILURE, payload: error };
};

const acknowledgeDisclaimerAction = () => {
  return { type: DISCLAIMER_ACKNOWLEDGED, payload: true };
};

const previouslyAcknowledgedDisclaimer = () => {
  return { type: DISCLAIMER_ACKNOWLEDGED, payload: true };
};

const invalidateDisclaimerAction = () => {
  return { type: DISCLAIMER_INVALIDATE_ACKNOWLEDGED, payload: false };
};

const createDataSiteHostAction = () => {
  return {
    type: CREATE_DATASITEHOST,
  };
};

const createDataSiteHostSuccessAction = (payload?: Bixby.Models.DataSiteHost[]) => {
  return {
    type: CREATE_DATASITEHOST_SUCCESS, payload 
  };
};

const createDataSiteHostFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: CREATE_DATASITEHOST_FAILURE,
    payload: error,
    
  };
};


export const getSettings = (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(settingsInProgress());
    try {
      const settings = await SettingsService.getAll();
      dispatch(settingsSuccess(settings));
      dispatch(checkDisclaimer());
    } catch (error: any) {
      dispatch(settingsFailure(error));
    }
  };
};

export const checkDisclaimer = (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    const disclaimerAcknowledged = DisclaimerService.getDisclaimer();
    if (Bixby.Utils.isDefined(disclaimerAcknowledged)) {
      dispatch(previouslyAcknowledgedDisclaimer());
    }
  };
};

export const acknowledgeDisclaimer = (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    DisclaimerService.setDisclaimer();
    dispatch(acknowledgeDisclaimerAction());
  };
};

export const invalidateDisclaimer = (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    DisclaimerService.setDisclaimer();
    dispatch(invalidateDisclaimerAction());
  };
};

export const updateSettings = (
  settings: Bixby.Models.Settings
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(settingsInProgress());
    try {
      await SettingsService.updateSettings(settings);
      dispatch(settingsSuccess());
      await dispatch(toastSuccess('Settings saved'));
    } catch (error: any) {
      await dispatch(toastError('Failed to save settings'));
      dispatch(settingsFailure(error));
    }
  };
};

export const getDataSiteHosts = (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    try {
      dispatch(dataSiteHostInProgress());
      const dataSiteHosts = await DataSiteHostService.getAll();
      await dispatch(dataSiteHostSuccess(dataSiteHosts));
    } catch (error: any) {
      dispatch(dataSiteHostFailure(error));
    }
  };
};

export const createDataSiteHost =
  (
    request: Bixby.Models.DataSiteHostRequest
  ): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(createDataSiteHostAction());
    try {
      const result = await DataSiteHostService.createDataSiteHost(request);
      await dispatch(createDataSiteHostSuccessAction(result));
      await dispatch(toastSuccess(`Data Site Host created`));
    } catch (error: any) {
      dispatch(createDataSiteHostFailureAction(error));
      await dispatch(toastError(`Error creating Data Site Host`));
    }
  };


